/** 현재 표시된 선택 항목 사이에서 포커스와 선택을 함께 이동합니다. */
export function moveChoiceFocus(event: KeyboardEvent): void {
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
    return;
  }
  const group = event.currentTarget;
  if (!(group instanceof HTMLElement)) {
    return;
  }
  const radio = group.getAttribute("role") === "radiogroup";
  const items = Array.from(
    group.querySelectorAll<HTMLElement>(radio ? '[role="radio"]' : '[role="tab"]'),
  ).filter(
    (item) => item.getClientRects().length > 0 && item.getAttribute("aria-disabled") !== "true",
  );
  const current = items.indexOf(event.target as HTMLElement);
  if (current < 0) {
    return;
  }
  let next: number;
  switch (event.key) {
    case "Home":
      next = 0;
      break;
    case "End":
      next = items.length - 1;
      break;
    case "ArrowRight":
      next = (current + 1) % items.length;
      break;
    case "ArrowLeft":
      next = (current - 1 + items.length) % items.length;
      break;
    case "ArrowDown":
      if (!radio) {
        return;
      }
      next = (current + 1) % items.length;
      break;
    case "ArrowUp":
      if (!radio) {
        return;
      }
      next = (current - 1 + items.length) % items.length;
      break;
    default:
      return;
  }
  event.preventDefault();
  items[next].focus();
  items[next].click();
}
